import React, { Component } from 'react';
import { v4 } from 'uuid';

export class RichTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: v4(),
            content: props.content,
            disabled: props.disabled
        };
        this.onInputChanged = this.onInputChanged.bind(this);
    }

    onInputChanged() {
        if (this.props.onChange) {
            this.props.onChange(window.$(`#${this.state.id}`).trumbowyg('html'));
        }
    }

    componentDidMount() {
        const { id, content, disabled } = this.state;
        window.$(`#${id}`).trumbowyg({
            btns: disabled ? [] : [
                ['bold', 'italic', 'underline', 'strikethrough'],
                ['unorderedList', 'orderedList'],
                ['foreColor', 'backColor'],
                ['superscript', 'subscript'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull']
            ],
            tagsToRemove: ['script', 'link', 'svg', 'embed', 'frame', 'iframe', 'img', 'a', 'xmp', 'object', 'applet', 'form'],
            semantic: false,
            removeformatPasted: true,
            autogrow: true,
            plugins: {
                colors: {
                    colorList: [
                        '000000', 'ffffff', 'C00000', 'FF0000', 'FFC000', 'FFFF00', '92D050', '00B050', '00B0F0', '0070C0', '002060', '7030A0'
                    ]
                }
            },
            disabled: disabled
        })
            .html(content ?? '')
            .on('tbwchange', () => this.onInputChanged());
    }

    componentDidUpdate(prevProps) {
        if (this.props.content !== prevProps.content && this.props.disabled) {
            this.setState({ content: this.props.content }, () => window.$(`#${this.state.id}`).html(this.props.content ?? ''));
        }
    }

    render() {
        const { id } = this.state;
        return (
            <div id={id}/>
        );
    }
}